import { createElement } from 'react';
import { Tab } from "@alifd/next";
const Tabs = function Tabs({ size, style, shape, tabArr, tabPosition, children, ...otherProps }) {
    return (createElement("div", null,
        createElement(Tab, { ...otherProps, shape: shape, tabPosition: tabPosition, size: size }, tabArr.map((item, index) => createElement(Tab.Item, { title: item.title, key: index }, item.content)))));
};
export default Tabs;
